import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';
import { FrequencyEnum, getSftpImportFrequencyDescriptions, SftpImportConfigurationWorkflow } from '../../../store/Models/Api/SftpImportModels';
import { DropdownMenu } from '../../core/DropdownMenu';

interface ScheduleConfigurationSectionLocalProps {
    configData: SftpImportConfigurationWorkflow;
    onConfigChange: (data: Partial<SftpImportConfigurationWorkflow>) => void;
    onTimeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onTimeBlur: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

type ScheduleConfigurationSectionProps = ScheduleConfigurationSectionLocalProps & ToxnotComponentProperties;

class ScheduleConfigurationSectionComponent extends ToxnotComponent<ScheduleConfigurationSectionProps> {
    public render() {
        const { configData, appServices, onConfigChange, onTimeChange, onTimeBlur } = this.props;

                const frequencyDescriptions = getSftpImportFrequencyDescriptions(appServices);
        

        return (
            <div className="group">
                <div className="title">{this.localizeString("Import Schedule")}</div>
                <div className="content">
                    <div className="form-group">
                        <label>{this.localizeString("Frequency")}</label>
                        <DropdownMenu
                            options={Object.values(FrequencyEnum)} // Just the values: ["Daily", "Weekly", "BiWeekly"]
                            value={configData.frequency}
                            onOptionSelected={option => onConfigChange({ frequency: option })}
                            getFriendlyNameForOptions={option => frequencyDescriptions[option] || option}
                            getUniqueValueForOption={option => option}
                        />
                        {configData.frequency === FrequencyEnum.Weekly && (
                            <small className="form-text text-muted" style={{ margin: '5px 0' }}>
                                {this.localizeString("Your scheduled weekly imports will be processed every weekend between Friday 7:00 PM and Saturday 6:59 PM EST.")}
                            </small>
                        )}
                        {configData.frequency === FrequencyEnum.BiWeekly && (
                            <small className="form-text text-muted" style={{ margin: '5px 0' }}>
                                {this.localizeString("Your scheduled bi-weekly imports will be processed every other weekend between Friday 7:00 PM and Saturday 6:59 PM EST.")}
                            </small>
                        )}
                    </div>
                    <div className="form-group">
                        <label>{this.localizeString("Start Time")}</label>
                        <input
                            type="time"
                            className="form-control"
                            value={configData.startTime}
                            onChange={onTimeChange}
                            onBlur={onTimeBlur}
                        />
                        <small className="form-text text-muted">{this.localizeString("The time will be rounded to the nearest 30-minute interval.")}</small>
                    </div>
                    <div className="form-group">
                        <label>{this.localizeString("Time Zone")}</label>
                        <DropdownMenu
                            options={[
                                { text: 'UTC', value: 'UTC' },
                                { text: 'EST', value: 'EST' },
                                { text: 'PST', value: 'PST' }
                            ]}
                            getFriendlyNameForOptions={(option) => option.text}
                            getUniqueValueForOption={(option) => option.value}
                            value={{ text: configData.timeZone || 'EST', value: configData.timeZone || 'EST' }}
                            onOptionSelected={(option) => onConfigChange({ timeZone: option.value })}
                            isDisabled={true}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export const ScheduleConfigurationSection = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(ScheduleConfigurationSectionComponent);
